import {BaseLineChart} from './LineChart'
import type {SplineChartProps} from '../types'

export const SplineChart = (props: SplineChartProps) => {
  return <BaseLineChart {...props} type="spline" />
}

try{ SplineChart.displayName ||= 'SplineChart' } catch {}